import { createSelector } from 'reselect';
import matchesProperty from 'lodash/matchesProperty';

import getLogisticsState from './getLogisticsState';

export default createSelector(
  getLogisticsState,
  matchesProperty('queries.center.status', 'loading'),
);
